import * as React from "react";
import { useTranslation } from "react-i18next";
import InvestigationsList from "./InvestigationsList";
import InvestigationsNumber from "./InvestigationsNumber";
import { LIST_MODE, NUMBER_MODE } from "./logic/InvestigationsWidgetConfig";
const InvestigationsVisualization = (props) => {
  var _a;
  const { t } = useTranslation("enterprise_security_investigations");
  const { config } = props;
  if (config.mode === LIST_MODE) {
    return /* @__PURE__ */ React.createElement(InvestigationsList, { ...props });
  }
  if (config.mode === NUMBER_MODE) {
    return /* @__PURE__ */ React.createElement(InvestigationsNumber, { ...props });
  }
  return /* @__PURE__ */ React.createElement("div", null, t("widget_visualization.unknown_mode", { mode: (_a = config.mode) != null ? _a : "undefined" }));
};
export default InvestigationsVisualization;
